import { Component, OnInit } from '@angular/core';

import { ModalClosedReason, ModalContent } from '@ap/modal';
import { ApContentModule } from '@ap/content';

import { ApSelectorOption } from '../../selector.modal';
import { ApSelectorModalSingleComponent } from '../single/selector-modal-single.component';

import { ApSelectorSubModalOptions } from './selector-sub-modal.model';

@Component({
    selector: 'ap-selector-sub-modal',
    templateUrl: './selector-sub-modal.component.html',
    imports: [ApSelectorModalSingleComponent, ApContentModule]
})
export class ApSelectorSubModalComponent extends ModalContent<ApSelectorSubModalOptions> implements OnInit {
    /**
     * All options for the selector
     */
    protected displayOptions: ApSelectorOption[];

    /**
     * Default options not formatted for display
     */
    private options: ApSelectorOption[];

    constructor() {
        super();
    }

    /**
     * On init of modal set correct options and diplay options
     */
    public ngOnInit(): void {
        const mainOption = this.modalOptions?.options?.option;
        this.options = mainOption?.subOptions || [];
        this.setDisplayOptions(mainOption);
    }

    /**
     * Select an option and close modal
     */
    protected select(displayOption: ApSelectorOption): void {
        const selectedOption = this.options.find((option) => displayOption.id === option.id);
        this.close(ModalClosedReason.SELECTED, selectedOption);
    }

    /**
     * Render display options to correct display options
     * In a submodal text is not shown in sub options that are not main option
     */
    private setDisplayOptions(mainOption: ApSelectorOption): void {
        this.displayOptions = this.options.map((subOption) => {
            if (subOption.id !== mainOption.id) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                return (({ text, ...o }) => o)(subOption); // remove b and c
            }
            return { ...subOption };
        });
    }
}
